// external imports
import React, { Component } from "react";
import { EditorState, getDefaultKeyBinding } from "draft-js";
import Editor from "draft-js-plugins-editor";
import createToolbarPlugin from "draft-js-static-toolbar-plugin";
import { connect } from "react-redux";

// internal imports
import { DOCUMENTS } from "../../constants";
import customBlockRenderer from "./BlockStyling";
import addLinkPlugin from "../RevvToolBar/plugins/addLinkPlugin";

// actions
import {
  updateComponentMeta,
  updateDocumentClickedComponentID,
} from "../../actions/DocumentActions/index";

const { FONT_SIZE_OPTIONS, FONT_FAMILY_OPTIONS, FONT_WEIGHT_OPTIONS } =
  DOCUMENTS;
const FONT_STYLE_OPTIONS = {
  ...FONT_SIZE_OPTIONS,
  ...FONT_FAMILY_OPTIONS,
  ...FONT_WEIGHT_OPTIONS,
};

const CUSTOM_STYLE_PREFIX = "FONT";
const CUSTOM_STYLE_FONT_SIZE_PREFIX = "FONTSIZE";
const CUSTOM_STYLE_FONT_COLOR_PREFIX = "FONTCOLOR";
const CUSTOM_STYLE_FONT_FAMILY_PREFIX = "FONTFAMILY";
const CUSTOM_STYLE_FONT_WEIGHT_PREFIX = "FONTWEIGHT";

function customStyleFn(style) {
  // Getting the all styles in one single string
  const styleNames = Array.isArray(style.toJS())
    ? style.toJS().toString()
    : style.toJS();

  // Method for getting the custom style
  const applyFontStyle = styleType => {
    const styleObj = {};
    if (
      typeof styleType === "string" &&
      styleType.startsWith(CUSTOM_STYLE_PREFIX)
    ) {
      if (styleType.startsWith(CUSTOM_STYLE_FONT_SIZE_PREFIX))
        styleObj.fontSize = FONT_SIZE_OPTIONS[styleType].fontSize;
      else if (styleType.startsWith(CUSTOM_STYLE_FONT_COLOR_PREFIX))
        styleObj.color = `#${styleType.split("_")[1]}`;
      else if (styleType.startsWith(CUSTOM_STYLE_FONT_FAMILY_PREFIX))
        styleObj.fontFamily = FONT_FAMILY_OPTIONS[styleType].fontFamily;
      else if (styleType.startsWith(CUSTOM_STYLE_FONT_WEIGHT_PREFIX))
        styleObj.fontWeight = FONT_WEIGHT_OPTIONS[styleType].fontWeight;
    }
    return styleObj;
  };

  // Check whether there are custom styles present or not
  let isCustomStylePresent = false;
  const splitedStyles = styleNames ? styleNames.split(",") : [];
  if (splitedStyles && splitedStyles.length > 0) {
    const findCusStyle = splitedStyles.find(stStyle =>
      stStyle.startsWith(CUSTOM_STYLE_PREFIX),
    );
    if (findCusStyle) {
      isCustomStylePresent = true;
    }
  }

  // If custom styles are present then, get the all font styles
  let fontStyle = {};
  if (isCustomStylePresent) {
    const stylesList = styleNames.split(",");
    fontStyle = stylesList.reduce((styles, styleName) => {
      if (typeof styleName === "string") {
        styles = {
          ...styles,
          ...applyFontStyle(styleName),
        };
      } else if (Array.isArray(styleNames)) {
        styleNames.forEach(name => {
          styles = {
            ...styles,
            ...applyFontStyle(name),
          };
        });
      }
      return styles;
    }, {});
  }
  return fontStyle;
}

const staticToolbarPlugin = createToolbarPlugin();
const plugins = [staticToolbarPlugin, addLinkPlugin];

const customKeyBinding = event => {
  const keyBinding = getDefaultKeyBinding(event);
  if (keyBinding === "undo") {
    return "handleUndo";
  }
  if (keyBinding === "redo") {
    return "handleRedo";
  }
  return keyBinding;
};

class ReadOnlyEditor extends Component {
  _handleEditEditorClick = () => {
    const { componentMeta, section } = this.props;
    if (!this.props.isComponentActive) {
      const { lock } = section;
      if (!lock) {
        this.props.updateComponentMeta({
          ...componentMeta,
        });
      }
      this.props.updateDocumentClickedComponentID(
        section.id,
        true,
        section ? section.type : null,
        true,
      );
      if (this.props.handleClick) {
        this.props.handleClick();
      }
    }
  };

  componentDidUpdate = () => {
    if (
      this.editEditor &&
      this.editEditor.editor &&
      this.editEditor.editor.editor
    ) {
      const element = this.editEditor.editor.editor;
      const firstChildEle = element.firstChild;
      if (
        firstChildEle &&
        firstChildEle.childNodes &&
        firstChildEle.childNodes.length > 0
      ) {
        firstChildEle.childNodes.forEach(ele => {
          ele.contentEditable = false;
        });
      }
    }
  };

  _getEditorState = () => this.props.editorState;

  // placeholder function
  _doNothing = () => false;

  render() {
    const { section, isComponentActive, editorState } = this.props;
    return (
      <div
        id={`readonly_editor_id_${section.id}`}
        className={`editor ${
          isComponentActive
            ? "active-editor  customtext-component active-customtext"
            : ""
        } `}
        onClick={this._handleEditEditorClick}
        onKeyPress={() => {}}
        role="button"
        tabIndex="0">
        {editorState && editorState instanceof EditorState && (
          <Editor
            section={this.props.section}
            customStyleMap={FONT_STYLE_OPTIONS}
            customStyleFn={customStyleFn}
            editorState={editorState}
            onChange={this._doNothing}
            handleKeyCommand={this._doNothing}
            handlePastedText={this._doNothing}
            keyBindingFn={customKeyBinding}
            blockRendererFn={customBlockRenderer(
              this._getEditorState,
              this._doNothing,
              this.props.readOnly,
              this.props.metaData,
              false,
            )}
            plugins={plugins}
            ref={element => {
              this.editEditor = element;
            }}
            readOnly
            data-test="readonlyEditor"
            handleDrop={() => "handled"}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {
  updateComponentMeta,
  updateDocumentClickedComponentID,
};

export default connect(null, mapDispatchToProps)(ReadOnlyEditor);
